import React from 'react';
import ForgotPasswordForm from '../components/ForgotPasswordForm';

const ForgotPasswordPage = props => (<ForgotPasswordForm />);

export default ForgotPasswordPage;
